import { useLocation } from "react-router-dom";
import { usePageView } from "../../hooks/use-page-view";
import { useScrollTracking } from "../../hooks/use-scroll-tracking";
import { useTimerEngagement } from "../../hooks/use-timer-engagement";

/**
 * Concentra os eventos de GTM que valem para qualquer rota: visualização de
 * página e os engajamentos de scroll e tempo. Não renderiza nada — precisa
 * apenas estar dentro do router para reagir à troca de rota.
 */
export function AnalyticsTracker(): null {
  const { pathname } = useLocation();

  usePageView(pathname);
  useScrollTracking(pathname);
  useTimerEngagement(pathname);

  return null;
}
